export default function ChapterDetail5(props) {
  document.title = props.text + " | Arisu";

	return (
    <>
      <p className="indent-8">
        The Caterpillar and Alice looked at each other for some time in silence: at
        last the Caterpillar took the hookah out of its mouth, and addressed her in a
        languid, sleepy voice.
      </p>
      <p className="indent-8">
        “Who are <i>you?</i>” said the Caterpillar.
      </p>
      <p className="indent-8">
        This was not an encouraging opening for a conversation. Alice replied, rather
        shyly, “I—I hardly know, sir, just at present—at least I know
        who I <i>was</i> when I got up this morning, but I think I must have been
        changed several times since then.”
      </p>
      <p className="indent-8">
        “What do you mean by that?” said the Caterpillar sternly.
        “Explain yourself!”
      </p>
      <p className="indent-8">
        “I can’t explain <i>myself</i>, I’m afraid, sir,” said
        Alice, “because I’m not myself, you see.”
      </p>
      <p className="indent-8">
        “I don’t see,” said the Caterpillar.
      </p>
      <p className="indent-8">
        “I’m afraid I can’t put it more clearly,” Alice replied
        very politely, “for I can’t understand it myself to begin with; and
        being so many different sizes in a day is very confusing.”
      </p>
      <p className="indent-8">
        “It isn’t,” said the Caterpillar.
      </p>
      <p className="indent-8">
        “Well, perhaps you haven’t found it so yet,” said Alice;
        “but when you have to turn into a chrysalis—you will some day, you
        know—and then after that into a butterfly, I should think you’ll
        feel it a little queer, won’t you?”
      </p>
      <p className="indent-8">
        “Not a bit,” said the Caterpillar.
      </p>
      <p className="indent-8">
        “Well, perhaps your feelings may be different,” said Alice;
        “all I know is, it would feel very queer to <i>me</i>.”
      </p>
      <p className="indent-8">
        “You!” said the Caterpillar contemptuously. “Who are
        <i>you?</i>”
      </p>
      <p className="indent-8">
        Which brought them back again to the beginning of the conversation. Alice felt
        a little irritated at the Caterpillar’s making such <i>very</i> short
        remarks, and she drew herself up and said, very gravely, “I think, you
        ought to tell me who <i>you</i> are, first.”
      </p>
      <p className="indent-8">
        “Why?” said the Caterpillar.
      </p>
      <p className="indent-8">
        Here was another puzzling question; and as Alice could not think of any good
        reason, and as the Caterpillar seemed to be in a <i>very</i> unpleasant state
        of mind, she turned away.
      </p>
      <p className="indent-8">
        “Come back!” the Caterpillar called after her. “I’ve
        something important to say!”
      </p>
      <p className="indent-8">
        This sounded promising, certainly: Alice turned and came back again.
      </p>
      <p className="indent-8">
        “Keep your temper,” said the Caterpillar.
      </p>
      <p className="indent-8">
        “Is that all?” said Alice, swallowing down her anger as well as she
        could.
      </p>
      <p className="indent-8">
        “No,” said the Caterpillar.
      </p>
      <p className="indent-8">
        Alice thought she might as well wait, as she had nothing else to do, and
        perhaps after all it might tell her something worth hearing. For some minutes
        it puffed away without speaking, but at last it unfolded its arms, took the
        hookah out of its mouth again, and said, “So you think you’re
        changed, do you?”
      </p>
      <p className="indent-8">
        “I’m afraid I am, sir,” said Alice; “I can’t
        remember things as I used—and I don’t keep the same size for ten
        minutes together!”
      </p>
      <p className="indent-8">
        “Can’t remember <i>what</i> things?” said the Caterpillar.
      </p>
      <p className="indent-8">
        “Well, I’ve tried to say “How doth the little busy
        bee,” but it all came different!” Alice replied in a very
        melancholy voice.
      </p>
      <p className="indent-8">
        “Repeat, “<i>You are old, Father William</i>,’” said
        the Caterpillar.
      </p>
      <p className="indent-8">
        Alice folded her hands, and began:—
      </p>
      <div className="grid justify-center">
        <p className="mt-2">“You are old, Father William,” the young man said,</p>
        <p className="indent-8">“And your hair has become very white;</p>
        <p className="mx-2">And yet you incessantly stand on your head—</p>
        <p className="indent-8 mb-2">Do you think, at your age, it is right?”</p>
        <p className="mx-2">“In my youth,” Father William replied to his son,</p>
        <p className="indent-8">“I feared it might injure the brain;</p>
        <p className="mx-2">But, now that I’m perfectly sure I have none,</p>
        <p className="indent-8 mb-2">Why, I do it again and again.”</p>
        <p className="mx-2">“You are old,” said the youth, “as I mentioned before,</p>
        <p className="indent-8">And have grown most uncommonly fat;</p>
        <p className="mx-2">Yet you turned a back-somersault in at the door—</p>
        <p className="indent-8 mb-2">Pray, what is the reason of that?”</p>
        <p className="mx-2">“In my youth,” said the sage, as he shook his grey locks,</p>
        <p className="indent-8">“I kept all my limbs very supple</p>
        <p className="mx-2">By the use of this ointment—one shilling the box—</p>
        <p className="indent-8 mb-2">Allow me to sell you a couple?”</p>
        <p className="mx-2">“You are old,” said the youth, “and your jaws are too weak</p>
        <p className="indent-8">For anything tougher than suet;</p>
        <p className="mx-2">Yet you finished the goose, with the bones and the beak—</p>
        <p className="indent-8 mb-2">Pray, how did you manage to do it?”</p>
        <p className="mx-2">“In my youth,” said his father, “I took to the law,</p>
        <p className="indent-8">And argued each case with my wife;</p>
        <p className="mx-2">And the muscular strength, which it gave to my jaw,</p>
        <p className="indent-8 mb-2">Has lasted the rest of my life.”</p>
        <p className="mx-2">“You are old,” said the youth, “one would hardly suppose</p>
        <p className="indent-8">That your eye was as steady as ever;</p>
        <p className="mx-2">Yet you balanced an eel on the end of your nose—</p>
        <p className="indent-8 mb-2">What made you so awfully clever?”</p>
        <p className="mx-2">“I have answered three questions, and that is enough,”</p>
        <p className="indent-8">Said his father; “don’t give yourself airs!</p>
        <p className="mx-2">Do you think I can listen all day to such stuff?</p>
        <p className="indent-8 mb-2">Be off, or I’ll kick you down stairs!”</p>
      </div>
      <p className="indent-8">
        “That is not said right,” said the Caterpillar.
      </p>
      <p className="indent-8">
        “Not <i>quite</i> right, I’m afraid,” said Alice, timidly;
        “some of the words have got altered.”
      </p>
      <p className="indent-8">
        “It is wrong from beginning to end,” said the Caterpillar
        decidedly, and there was silence for some minutes.
      </p>
      <p className="indent-8">
        The Caterpillar was the first to speak.
      </p>
      <p className="indent-8">
        “What size do you want to be?” it asked.
      </p>
      <p className="indent-8">
        “Oh, I’m not particular as to size,” Alice hastily replied;
        “only one doesn’t like changing so often, you know.”
      </p>
      <p className="indent-8">
        “I <i>don’t</i> know,” said the Caterpillar.
      </p>
      <p className="indent-8">
        Alice said nothing: she had never been so much contradicted in her life before,
        and she felt that she was losing her temper.
      </p>
      <p className="indent-8">
        “Are you content now?” said the Caterpillar.
      </p>
      <p className="indent-8">
        “Well, I should like to be a <i>little</i> larger, sir, if you
        wouldn’t mind,” said Alice: “three inches is such a wretched
        height to be.”
      </p>
      <p className="indent-8">
        “It is a very good height indeed!” said the Caterpillar angrily,
        rearing itself upright as it spoke (it was exactly three inches high).
      </p>
      <p className="indent-8">
        “But I’m not used to it!” pleaded poor Alice in a piteous
        tone. And she thought of herself, “I wish the creatures wouldn’t be
        so easily offended!”
      </p>
      <p className="indent-8">
        “You’ll get used to it in time,” said the Caterpillar; and it
        put the hookah into its mouth and began smoking again.
      </p>
      <p className="indent-8">
        This time Alice waited patiently until it chose to speak again. In a minute or
        two the Caterpillar took the hookah out of its mouth and yawned once or twice,
        and shook itself. Then it got down off the mushroom, and crawled away in the
        grass, merely remarking as it went, “One side will make you grow taller,
        and the other side will make you grow shorter.”
      </p>
      <p className="indent-8">
        “One side of <i>what?</i> The other side of <i>what?</i>” thought
        Alice to herself.
      </p>
      <p className="indent-8">
        “Of the mushroom,” said the Caterpillar, just as if she had asked
        it aloud; and in another moment it was out of sight.
      </p>
      <p className="indent-8">
        Alice remained looking thoughtfully at the mushroom for a minute, trying to
        make out which were the two sides of it; and as it was perfectly round, she
        found this a very difficult question. However, at last she stretched her arms
        round it as far as they would go, and broke off a bit of the edge with each
        hand.
      </p>
      <p className="indent-8">
        “And now which is which?” she said to herself, and nibbled a little
        of the right-hand bit to try the effect: the next moment she felt a violent
        blow underneath her chin: it had struck her foot!
      </p>
      <p className="indent-8">
        She was a good deal frightened by this very sudden change, but she felt that
        there was no time to be lost, as she was shrinking rapidly; so she set to work
        at once to eat some of the other bit. Her chin was pressed so closely against
        her foot, that there was hardly room to open her mouth; but she did it at last,
        and managed to swallow a morsel of the lefthand bit.
      </p>
      <p className="my-2 p-2 text-center tracking-tighter">
        &lt;&gt;&lt;&gt;&lt;&gt;&lt;&gt;
      </p>
      <p className="indent-8">
        “Come, my head’s free at last!” said Alice in a tone of
        delight, which changed into alarm in another moment, when she found that her
        shoulders were nowhere to be found: all she could see, when she looked down,
        was an immense length of neck, which seemed to rise like a stalk out of a sea
        of green leaves that lay far below her.
      </p>
      <p className="indent-8">
        “What <i>can</i> all that green stuff be?” said Alice. “And
        where <i>have</i> my shoulders got to? And oh, my poor hands, how is it I
        can’t see you?” She was moving them about as she spoke, but no
        result seemed to follow, except a little shaking among the distant green
        leaves.
      </p>
      <p className="indent-8">
        As there seemed to be no chance of getting her hands up to her head, she tried
        to get her head down to them, and was delighted to find that her neck would
        bend about easily in any direction, like a serpent. She had just succeeded in
        curving it down into a graceful zigzag, and was going to dive in among the
        leaves, which she found to be nothing but the tops of the trees under which she
        had been wandering, when a sharp hiss made her draw back in a hurry: a large
        pigeon had flown into her face, and was beating her violently with its wings.
      </p>
      <p className="indent-8">
        “Serpent!” screamed the Pigeon.
      </p>
      <p className="indent-8">
        “I’m <i>not</i> a serpent!” said Alice indignantly.
        “Let me alone!”
      </p>
      <p className="indent-8">
        “Serpent, I say again!” repeated the Pigeon, but in a more subdued
        tone, and added with a kind of sob, “I’ve tried every way, and
        nothing seems to suit them!”
      </p>
      <p className="indent-8">
        “I haven’t the least idea what you’re talking about,”
        said Alice.
      </p>
      <p className="indent-8">
        “I’ve tried the roots of trees, and I’ve tried banks, and
        I’ve tried hedges,” the Pigeon went on, without attending to her;
        “but those serpents! There’s no pleasing them!”
      </p>
      <p className="indent-8">
        Alice was more and more puzzled, but she thought there was no use in saying
        anything more till the Pigeon had finished.
      </p>
      <p className="indent-8">
        “As if it wasn’t trouble enough hatching the eggs,” said the
        Pigeon; “but I must be on the look-out for serpents night and day! Why, I
        haven’t had a wink of sleep these three weeks!”
      </p>
      <p className="indent-8">
        “I’m very sorry you’ve been annoyed,” said Alice, who
        was beginning to see its meaning.
      </p>
      <p className="indent-8">
        “And just as I’d taken the highest tree in the wood,”
        continued the Pigeon, raising its voice to a shriek, “and just as I was
        thinking I should be free of them at last, they must needs come wriggling down
        from the sky! Ugh, Serpent!”
      </p>
      <p className="indent-8">
        “But I’m <i>not</i> a serpent, I tell you!” said Alice.
        “I’m a—I’m a—”
      </p>
      <p className="indent-8">
        “Well! <i>What</i> are you?” said the Pigeon. “I can see
        you’re trying to invent something!”
      </p>
      <p className="indent-8">
        “I—I’m a little girl,” said Alice, rather doubtfully,
        as she remembered the number of changes she had gone through that day.
      </p>
      <p className="indent-8">
        “A likely story indeed!” said the Pigeon in a tone of the deepest
        contempt. “I’ve seen a good many little girls in my time, but never
        <i>one</i> with such a neck as that! No, no! You’re a serpent; and
        there’s no use denying it. I suppose you’ll be telling me next that
        you never tasted an egg!”
      </p>
      <p className="indent-8">
        “I <i>have</i> tasted eggs, certainly,” said Alice, who was a very
        truthful child; “but little girls eat eggs quite as much as serpents do,
        you know.”
      </p>
      <p className="indent-8">
        “I don’t believe it,” said the Pigeon; “but if they do,
        why then they’re a kind of serpent, that’s all I can say.”
      </p>
      <p className="indent-8">
        This was such a new idea to Alice, that she was quite silent for a minute or
        two, which gave the Pigeon the opportunity of adding, “You’re
        looking for eggs, I know <i>that</i> well enough; and what does it matter to me
        whether you’re a little girl or a serpent?”
      </p>
      <p className="indent-8">
        “It matters a good deal to <i>me</i>,” said Alice hastily;
        “but I’m not looking for eggs, as it happens; and if I was, I
        shouldn’t want <i>yours</i>: I don’t like them raw.”
      </p>
      <p className="indent-8">
        “Well, be off, then!” said the Pigeon in a sulky tone, as it
        settled down again into its nest. Alice crouched down among the trees as well
        as she could, for her neck kept getting entangled among the branches, and every
        now and then she had to stop and untwist it. After a while she remembered that
        she still held the pieces of mushroom in her hands, and she set to work very
        carefully, nibbling first at one and then at the other, and growing sometimes
        taller and sometimes shorter, until she had succeeded in bringing herself down
        to her usual height.
      </p>
      <p className="indent-8">
        It was so long since she had been anything near the right size, that it felt
        quite strange at first; but she got used to it in a few minutes, and began
        talking to herself, as usual. “Come, there’s half my plan done now!
        How puzzling all these changes are! I’m never sure what I’m going
        to be, from one minute to another! However, I’ve got back to my right
        size: the next thing is, to get into that beautiful garden—how <i>is</i>
        that to be done, I wonder?” As she said this, she came suddenly upon an
        open place, with a little house in it about four feet high. “Whoever
        lives there,” thought Alice, “it’ll never do to come upon
        them <i>this</i> size: why, I should frighten them out of their wits!” So
        she began nibbling at the righthand bit again, and did not venture to go near
        the house till she had brought herself down to nine inches high.
      </p>
    </>
  )
}